import $ from 'jquery';

export function ClickOutside() {
  $(document).on('click', function(e) {
    if ($(e.target).attr('id') !== 'navbarNavDropdown') {
      $('#navbarNavDropdown').collapse('hide');
    }
  });
}
